import {SalaryMode} from '../enums/salary-mode.enum';

export default class SalaryUtils {

  static calculateNetPerHourSalary(type: number, salary: number): number {
    let netPerHour = 0;
    salary = salary ? parseFloat(salary.toString().replace(',', '.')) : 0;
    switch (type) {
      case 0:
        netPerHour = salary;
        break;
      case 1:
        netPerHour = salary * 2.1025;
        break;
      case 2:
        netPerHour = salary * 1.469;
        break;
      case 3:
        netPerHour = salary * 1.17;
        break;
      default:
        netPerHour = 0;
    }
    return netPerHour;
  }

  static countNetRateBasedOnSalaryMode(netRate: number, salaryMode: SalaryMode): string {
    if (salaryMode === SalaryMode.Monthly) {
      return (netRate / 168).toFixed(2).replace('.', ',');
    } else {
      return (netRate).toFixed(2).replace('.', ',');
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/interviews/salary-utils.ts